import { useState } from "react";
import { toast } from 'react-hot-toast';
import { useHistory, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from '../components/elements';
import { getError } from '../util/index';

import Logo from "../assets/images/Sterling-Logo_.svg";
import Hidden from "../assets/images/Vector.png";
import siginBg from "../assets/images/signin.png";

export default function LoginPage() {
  const { signin, loading } = useAuth();
  const [userData, setUserData] = useState({ 'email': '', 'password': '', 'role': 'User' });
  const history = useHistory();

  const handleChange = ({ target: { name, value } }) => {
    setUserData(prevState => ({ ...prevState, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const res = await signin(userData)
    if (res === true) {
      toast.success(`Welcome!`);
      history.push('/products')
    } else {
      getError(res);
    }
  }

  return (
    <div
      className="min-h-screen relative bg-black text-white p-6 md:px-32 bg-cover"
      style={{ backgroundImage: `url(${siginBg})` }}
    >
      <nav className="w-40 ">
        <img src={Logo} className="w-full" alt="logo" />
      </nav>
      <section className="flex flex-wrap justify-between items-center mt-20">
        <p className="w-full md:w-6/12 text-4xl md:text-6xl font-bold text-center md:text-left" style={{lineHeight: '75px'}}>
          Welcome Back. <br />Enjoy amazing <br className="hidden md:inline"/> deals curated<br className="hidden md:inline"/> just for you
        </p>
        <div className="w-full md:w-6/12 flex justify-center">
          <div className="bg-black rounded-3xl md:w-8/12 md:p-16 p-10 my-8 md:my-0">
            <h1 className="text-center text-3xl mb-5">Louvarian</h1>
            <form action="">
              <div className="my-6">
                <label htmlFor="email" className="block text-xs mb-2">
                  EMAIL ADDRESS
                </label>
                <input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  placeholder="test@test.com"
                  className="bg-gray2 rounded-md pl-3 p-3 w-80 my-2 text-white text-opacity-60 w-full"
                />
              </div>
              <div className="my-6">
                <label htmlFor="password" className="block text-xs mb-2">
                  PASSWORD
                </label>
                <div className="flex relative justify-items-center">
                  <input
                    type="password"
                    name="password"
                    onChange={handleChange}
                    placeholder="password"
                    className="p-3 pl-3 bg-gray2 rounded-md w-80 my-2 text-white text-opacity-60 w-full"
                  />
                  <img
                    src={Hidden}
                    className="absolute right-4 top-5 "
                    alt="hidden"
                  />
                </div>
                <p className="text-right text-sm">Forgot Password</p>
              </div>
              <div>
                <button onClick={handleSubmit} className="bg-primary rounded-md cursor-pointer w-full p-2 text-center flex items-center justify-center">
                  {loading ? <Spinner color="#fff" size="w-5 h-5" /> : 'Log in'}
                </button>
                <p className="text-center mt-3 text-sm">
                  Don't have an account?{" "}
                  <span>
                    <Link to="/signup" className="text-red-600">
                      Sign Up
                    </Link>
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}